const DATAHUB_TRANSLATION_KEYS = {
  "EUR/USD LME-FX-rate (MTLE)": "Datahub_€$_LME_FX_Rate",
  "ECB-Fixing (14:15 Uhr)": "Datahub_ECB_Fixing",
  "Reference Rate EUR/USD (BFIX)": "Datahub_Ref_Rate_€$_BFIX",
  "EUR/USD-Basis DEL-Notiz": "Datahub_€$_denom_DEL_Rate",
  "Brass MS 63 for wire": "Datahub_Brass_MS63_wire",
  "MK Copper": "Datahub_MK_Copper",
  "Bronze 94/6": "Datahub_Bronze_94_6",
  "Brass MS 58, 1st processing level": "Datahub_Brass_MS58_1",
  "Brass MS 58, 2st processing level": "Datahub_Brass_MS58_2",
  "MP 58": "Datahub_MP58",
  "Brass MS 63/37": "Datahub_Brass63_37",
  "Lower-rate copper DEL rates": "Datahub_LrcDELr",
  "Higher-rate copper DEL rates": "Datahub_HrcDELr",
  "Aluminum conductive": "Datahub_Aluminum_Conductive",
  "Aluminum for cables": "Datahub_Aluminum_Cables",
  "Lead in cables": "Datahub_Lead_Cables",
}

export const getDatahubTranslationKey = key =>
  DATAHUB_TRANSLATION_KEYS[key] || "Datahub_" + key
